<template>
<div
  style="width: 20rem; height: min-content;"
  class="pa-5 info  d-flex flex-column align-center"
>
  <v-icon
    color="primary"
  >{{ icon }}</v-icon>
  <p class="ma-0 pt-1 font-weight-bold">{{ count }}</p>
  <p class="text-subtitle-3 ma-0">{{ title }}</p>

</div>
</template>

<script>
export default {
  name: "SummarySection",
  props: {
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    count: {
      type: [String, Number],
      required: false,
    },

  },
};
</script>
